import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuelKpiSummaryResponse } from '../../_shared/models/fuel-kpi-response.model';
import { Response } from '../../../_shared/models';
import { environment } from '../../../../environments/environment';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { FuelCostKpiRequest } from '../models/fuel-cost-kpi-request.model';
import { FuelInsightsRequest } from '../../_shared';
import { FuelInsightsResponse } from '../../_shared/models/fuel-insights-response.model';

@Injectable({
  providedIn: 'root'
})
export class FuelCostService {

  constructor(private http: HttpClient) { }

  public getFuelCostSummary(request: FuelCostKpiRequest, cancellation: Subject<void>): Promise<Response<FuelKpiSummaryResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboard/fuel-cost-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getFuelCostPerVolumeInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/FuelDashBoardInsights/fuel-cost/cost-per-volume-insights`, request).pipe(takeUntil(cancellation)));
  }
}
